module.exports = __webpack_public_path__ + "cf218fd6a0feaf95ce1be82d37f053bb.pdf";